import { Divider, Text, Flex } from "@mantine/core"

export const GRID_TEMPLATE = "minmax(200px,2.5fr) minmax(120px,1.2fr) 80px 80px"

export const FileExplorerHeader = () => (
  <>
    <Flex
      display="grid"
      w="100%"
      align="center"
      mt={16}
      mb={0}
      style={{ gridTemplateColumns: GRID_TEMPLATE }}
    >
      <Text fw="bold" ta="left" pl={20}>
        Name
      </Text>
      <Text fw="bold" ta="right" pr="10%">
        Tags
      </Text>
      <Text fw="bold" ta="left">
        Owner
      </Text>
      <Text fw="bold" ta="left">
        Privacy
      </Text>
    </Flex>
    <Divider color="surfaceHeader" />
  </>
)
